/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {ChangeDetectorRef, Directive, Inject, Optional} from '@angular/core';

import {OompaLoompa} from '../../../utils/chocolate/oompa-loompa';
import {IF_ACTIVE_ID, IfActiveService} from '../../../utils/conditional/if-active.service';

import {TabsWillyWonka} from './tabs-willy-wonka';
export class ActiveOompaLoompa extends OompaLoompa {
private ifActive: IfActiveService;
private id: number;
/**
 * @param {?} cdr
 * @param {?} willyWonka
 * @param {?} id
 * @param {?} ifActive
 */
constructor(cdr: ChangeDetectorRef,  willyWonka: TabsWillyWonka,  id: number,
                ifActive: IfActiveService) {
        if (!willyWonka) {
            throw new Error("clrTabLink and clr-tab-content should only be used inside of a clr-tabs");
        }
        super(cdr, willyWonka);
        this.ifActive = ifActive;
        this.id = id;
    }
/**
 * @return {?}
 */
get flavor() {
        return this.ifActive.current === this.id;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrTabLink], clr-tab-content"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: TabsWillyWonka, decorators: [{ type: Optional }, ]},
{type: undefined, decorators: [{ type: Inject, args: [IF_ACTIVE_ID, ] }, ]},
{type: IfActiveService, },
];
}

function ActiveOompaLoompa_tsickle_Closure_declarations() {
/** @type {?} */
ActiveOompaLoompa.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ActiveOompaLoompa.ctorParameters;
/** @type {?} */
ActiveOompaLoompa.prototype.ifActive;
/** @type {?} */
ActiveOompaLoompa.prototype.id;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
